module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/about-reserve-d6e016ea644a71fd4b65631b9d0f86b7.png";